Ext.ns('mx.comp');

mx.comp.Image = Ext.extend(Ext.Panel, {
    tpl: new Ext.XTemplate('<img src="{src}" alt="{alt}" ext:qtip="{tooltip}"/>'),
    tplEmpty: new Ext.XTemplate(''),
    layout: 'fit',
    cache: null,
    afterRender: function() {
        mx.comp.Image.superclass.afterRender.apply(this, arguments);
        if (this.cache) {
            this.src += '?';
            this.src += this.cache + (this.params ? '&' : '');
        }
        if (this.params) {
            this.src += '?';
            for (var p in this.params) {
                this.src = p + '=' + this.params[p] + '&';
            }
        }
        // create image
        if (this.src) {
            this.tpl.overwrite(this.body, this);
        } else {
            this.tplEmpty.overwrite(this.body, this);
        }
    },
    setParams: function(params) {
        this.params = params;
        this.afterRender();
    },
});

Ext.reg('mx_image', mx.comp.Image);
